<template>
  <div class="main">
    <div class="float-right">
      <v-btn
        @click="action2"
        rounded
        color="primary"
        class="text-capitalize"
        v-if="show2"
        >publicar
        <v-icon class="ml-2" size="small">mdi-earth</v-icon></v-btn
      >
      <v-btn
        @click="action1"
        rounded
        color="primary"
        class="ml-3 text-capitalize"
        >editar no simulador
        <v-icon class="ml-2" size="small"
          >mdi-square-edit-outline</v-icon
        ></v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "HandlePlanMenu",
  methods: {
    action1() {
      this.$emit("action1");
    },
    action2() {
      this.$emit("action2");
    }
  },
  computed: {
    show2() {
        return this.$store.getters.getAllow(2);
    }
  }
};
</script>

<style scoped>
.main {
  display: table;
  width: 100%;
}
</style>
